module.exports = __webpack_public_path__ + "static/media/refresh.5234f37d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/refresh.svg
// module id = 944
// module chunks = 5